export default __webpack_public_path__ + "static/dojo-inspo-hero-b485c1170b1057bd2ec327ef2b1a8e95.svg";